module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-9.29939677.jpg";